module.exports = __webpack_public_path__ + "img/ic_no-search.1b86ac8b.svg";